import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type ModalShellSize = 'default' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-modal-shell',
  templateUrl: './modal-shell.component.html',
  styleUrls: ['./modal-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalShellComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() closeLabel = 'Close';
  @Input() sopMode = false;
  @Input() size: ModalShellSize = 'default';
  @Output() close = new EventEmitter<void>();
}
